export default __webpack_public_path__ + "static/media/elcom1.2a01a6a5.png";